// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ion-palette-dark.ios ion-modal {
    --ion-background-color: var(--ion-background-color-step-100);
    --ion-toolbar-background: var(--ion-background-color-step-150);
    --ion-toolbar-border-color: var(--ion-background-color-step-250);
}
.ion-palette-dark.ios :root.scanner-active ion-modal {
    --ion-background-color: transparent !important;
    --ion-toolbar-background: transparent !important;
    --ion-toolbar-border-color: transparent !important;
}

:root.scanner-active {
    --background: transparent;
    --ion-background-color: transparent;
}

.ion-palette-dark {
    ion-card {
        --background: #363636;
    }
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
